import { render } from "./Support.vue?vue&type=template&id=59a2e15c&scoped=true&ts=true"
import script from "./Support.vue?vue&type=script&lang=ts"
export * from "./Support.vue?vue&type=script&lang=ts"

import "./Support.vue?vue&type=style&index=0&id=59a2e15c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a2e15c"]])

export default __exports__